import axios from "axios";

axios.defaults.baseURL = "https://company-backend.developnetwork.net/api";
// axios.defaults.baseURL = "https://study-backend.developnetwork.net/api";



export default axios;


